export let debug = false

export const setDebug = (value) => {
  debug = value
}
